import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { createSafeStorage } from "./safeStorage";

export type Consent = "granted" | "denied" | null;

interface ConsentState {
  consent: Consent;
}

interface ConsentActions {
  accept: () => void;
  decline: () => void;
  resetConsent: () => void;
}

export type ConsentStore = ConsentState & ConsentActions;

/** Whether third-party analytics (PostHog/Sentry) may run. Off only on explicit denial. */
export function isExternalAnalyticsAllowed(consent: Consent): boolean {
  return consent !== "denied";
}

export const useConsentStore = create<ConsentStore>()(
  persist<ConsentStore, [], [], ConsentState>(
    (set) => ({
      consent: null,
      accept: () => set(() => ({ consent: "granted" })),
      decline: () => set(() => ({ consent: "denied" })),
      resetConsent: () => set(() => ({ consent: null })),
    }),
    {
      name: "bgb_consent",
      storage: createJSONStorage(() => createSafeStorage()),
      partialize: (state) => ({ consent: state.consent }),
    },
  ),
);
